import axios from "axios";
import moment from "moment";
import qs from "qs";
import appAxios from "./axios";

export const paymentsService = {
    // @deprecated moved to the backend
    create2: async (input) => {
        /**
         * 
         * Amount - Общая сумма заказа.<br />
<b>Поле: </b>25<br />
         * <b>Формат: </b>Цифровое<br />
         * <b>Наличие: </b>Обязательное
         * 
         * 398 - KZT Валюта заказа: 3-символьный код валюты.<br />
         * 398=тенге<br />
         * <b>Поле: </b>26<br />
         * <b>Формат: </b>Строка (3)<br />
         * <b>Наличие: </b>Обязательное
         * 
         * ORDER: Номер заказа интернет-магазина.<br />
         * <b>Поле: </b>27<br />
         * <b>Формат: </b>Цифровое (6-32)<br />
         * <b>Наличие: </b>Обязательное
         * 
         * DESC: Описание заказа интернет-магазина.<br />
         * <b>Поле: </b>58<br />
         * <b>Формат: </b>Строка (125)<br />
         * <b>Наличие: </b>Обязательное
         * 
         * MERCHANT: Идентификатор интернет-торговца входящей транзакции.<br />
         * <b>Поле: </b>29<br />
         * <b>Формат: </b>Цифровое<br />
         * <b>Наличие: </b>Обязательное
         * 
         * MERCH_NAME: Имя торговца. Параметр всегда должен быть написан UPPERCASE'ом<br />
         * <b>Поле: </b>53<br />
         * <b>Формат: </b>Строка (21) на латинице<br />
         * <b>Наличие: </b>Обязательное
         * 
         * MERCH_URL: URL сайта торговца.<br />
         * <b>Поле: </b>55<br />
         * <b>Формат: </b>Строка (250)<br />
         * <b>Наличие: </b>Произвольное
         * 
         * COUNTRY: 2-символьный код страны магазина торговца.<br />
         * <b>Поле: </b>54<br />
         * <b>Формат: </b>Строка (3)<br />
         * <b>Наличие: </b>Обязательное
         * 
         * BRANDS: Список допустимых платежных систем.<br />
         * Список, через запятую, торговых марок, карты которых принимает торговец.<br />
         * <b>Поле: </b>57<br />
         * <b>Формат: </b>Строка (80)<br />
         * <b>Наличие: </b>Произвольное
         * 
         * TERMINAL: Номер терминала торговца.<br />
         * Идентификатор терминала торговца.<br />
         * <b>Поле: </b>21<br />
         * <b>Формат: </b>Строка<br />
         * <b>Наличие: </b>Обязательное
         * 
         * TIMESTAMP: Временная метка транзакции.<br />
         * Временная отметка транзакции торговца по времени GMT.<br />
         * <b>Поле: </b>47<br />
         * <b>Формат: </b>ГГГГММДДЧЧММСС<br />
         * <b>Наличие: </b>Обязательное
         * 
         * MERCH_GMT: Часовой пояс торговца.<br />
         * Сдвиг часового пояса торговца относительно UTC/GMT.<br />
         * <b>Поле: </b>56<br />
         * <b>Формат: </b>Знак и число (1)<br />
         * <b>Наличие: </b>Обязательное
         * 
         * TRTYPE: Тип транзакции.<br />
         * Тип транзакции. Необходимо задать равным "0". <br />
         * <b>Поле: </b>22<br />
         * <b>Формат: </b>Цифровое<br />
         * <b>Наличие: </b>Обязательное
         * 
         * BACKREF: URL торговца для отправки результата авторизации.<br />
         * <b>Поле: </b>41<br />
         * <b>Формат: </b>URL<br />
         * <b>Наличие: </b>Произвольное
         * 
         * LANG: Язык транзакции (kz, ru, en). Значение данного поля будет использовано в качестве расширения файла сообщения.<br />
         * <b>Поле: </b>31<br />
         * <b>Формат: </b>Строка (3)<br />
         * <b>Наличие: </b>Обязательное
         * 
         * NONCE: Случайное число, генерируемое торговцем для каждой транзакции.<br />
         * Случайный идентификатор транзакции.<br />
         * Случайная комбинация длиной в 8-32 байт в шестнадцатеричном формате.<br />
         * <b>Поле: </b>61<br />
         * <b>Формат: </b>Строка (16-64)<br />
         * <b>Наличие: </b>Обязательное
         * 
         * P_SIGN: Подпись транзакции.<br />
         * Код аутентификации сообщений (MAC).<br />
         * <b>Поле: </b>44<br />
         * <b>Формат: </b>Строка (длина зависит от типа подписи и используемого алгоритма формирования)<br />
         * <b>Наличие: </b>Обязательное
         * 
         * MK_TOKEN: Запрос на создание токена во время другой операции:<br />
         * MERCH – только для номера карты источника.<br />
         * <b>Поле: </b>224<br />
         * <b>Формат: </b>Строка<br />
         * <b>Наличие: </b>Произвольное
         * 
         * NOTIFY_URL: URL сайта торговца для передачи уведомления. Значение обязательно должен быть указан с портом.<br />
         * <b>Поле: </b>190<br />
         * <b>Формат: </b>URL<br />
         * <b>Наличие: </b>Произвольное
         * 
         * CLIENT_IP: IP-адрес клиента.<br />
         * IP-адрес клиента-источника транзакции.<br />
         * <b>Поле: </b>374<br />
         * <b>Наличие: </b>Обязательное для 3DS операции<br />
         * 0.0.0.0 - это пример. Вместо него указываете IP-адрес клиента-источника транзакции.
         * 
         * M_INFO: Набор данных 3DS v2, передаваемых торговцем. Строковое представление (в кодировке Base64) JSON формата данных (параметры и их значения). Описание полного набора обязательных параметров представлено в разделе "3DSECURE 2.X.X" -> "M_INFO" -> "EMV 3-D Secure Protocol".<br />
         * <b>Поле: </b>389<br />
         * <b>Формат: </b>Строка<br />
         * <b>Наличие: </b>Обязательное для 3DS операции<br />
         * Приведенное значение является всего лишь примером. Вместо него указываете свое значение в формате Base64. Cкрипты кода и обязятельные параметры JSON представлены в разделе "3DSECURE 2.X.X" -> "M_INFO" -> "Code scripts".
         */

        // TODO: add mInfo, clientIP, P_SIGN

        const paymentInput = {
            "AMOUNT": 10000,
            "CURRENCY": 398,
            "ORDER": input.bookingID,
            "DESC": input.tourPackage.name,
            "MERCHANT": `00000001`,
            "MERCH_NAME": `ТОО "HAJJTRAVEL"`,
            "MERCH_URL": `https://hajjtravel.kz`,
            "COUNTRY": `KZ`,
            "BRANDS": `VISA,MASTERCARD`,
            "TERMINAL": 88888881,
            "TIMESTAMP": moment().format('YYYYMMDDHHmmss'),
            "MERCH_GMT": '+6',
            "TRTYPE": 0,
            "BACKREF": `https://hajjtravel.kz/payments/callback`,
            "LANG": `ru`,
            "NONCE": moment().unix().toString(16),
            "P_SIGN": `5298E314E550AB9E46650D4080774A54F93BF741`,
            "MK_TOKEN": `MERCH`,
            "NOTIFY_URL": `https://api.hajjtravel.kz:443/payments/callback`,
            "CLIENT_IP": `127.0.0.1`,
            "M_INFO": `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c`
        }

        // Convert paymentInput to URLSearchParams for x-www-form-urlencoded

        const data = qs.stringify(paymentInput);

        const response = await axios({
            method: "post",
            url: `${process.env.REACT_APP_PAYMENT_ADDRESS}`,
            data: data,
            headers: {},
            maxBodyLength: Infinity,
        });
        return response.data;
    },

    // Предоплата. По зопросу возврщает форму банка
    create: async (orderID, type) => {
        /**
         * Callback data: FormData {
            5|hajjtravel-api  |   "ACTION": "3",
            5|hajjtravel-api  |   "RC": "-17",
            5|hajjtravel-api  |   "RC_TEXT": "Отказано в доступе",
            5|hajjtravel-api  |   "APPROVAL": "",
            5|hajjtravel-api  |   "TRAN_CUR_NAME": "",
            5|hajjtravel-api  |   "TRAN_AMOUNT": "",
            5|hajjtravel-api  |   "CARD_MASK": "4463XXXXXXXX4568",
            5|hajjtravel-api  |   "TERMINAL": "88888881",
            5|hajjtravel-api  |   "TRTYPE": "0",
            5|hajjtravel-api  |   "AMOUNT": "10000",
            5|hajjtravel-api  |   "CURRENCY": "398",
            5|hajjtravel-api  |   "ORDER": "1744717155697",
            5|hajjtravel-api  |   "RRN": "",
            5|hajjtravel-api  |   "MERCHANT": "00000001",
            5|hajjtravel-api  |   "LANG": "ru",
            5|hajjtravel-api  |   "ZIP": "",
            5|hajjtravel-api  |   "AVS": "",
            5|hajjtravel-api  |   "EMAIL": "serik.shaikamalov@gmail.com",
            5|hajjtravel-api  |   "NAME": "shaikamalov serik",
            5|hajjtravel-api  |   "BACKREF": "https://api.hajjtravel.kz:443/tourpackages/cuS52O2287xX0pYZgZwOD/create?type=prepayment",
            5|hajjtravel-api  |   "orderID": "cuS52O2287xX0pYZgZwOD",
            5|hajjtravel-api  |   "P_SIGN": "5298E314E550AB9E46650D4080774A54F93BF741",
            5|hajjtravel-api  |   "TIMESTAMP": "20250415113945",
            5|hajjtravel-api  |   "CVC2_RC": "",
            5|hajjtravel-api  |   "INT_REF": "",
            5|hajjtravel-api  |   "MERCH_NAME": "ТОО \"HAJJTRAVEL\"",
            5|hajjtravel-api  |   "COUNTRY": "KZ",
            5|hajjtravel-api  |   "MERCH_URL": "https://hajjtravel.kz",
            5|hajjtravel-api  |   "MERCH_GMT": " 6",
            5|hajjtravel-api  |   "BRANDS": "VISA,MASTERCARD",
            5|hajjtravel-api  |   "DESC": "Testing",
            5|hajjtravel-api  |   "NONCE": "67fe4563",
            5|hajjtravel-api  |   "MERCH_TOKEN_ID": "",
            5|hajjtravel-api  | }
         */

        // По номеру заказа получаем информацию о турпакете, полную стоимость и предоплату, информацию о клиенте
        const response = await appAxios.get(`/app/bcc/payments/create?orderID=${orderID}&type=${type}`);
        return response.data;
    },
}
